import locale77830b2a from '../..\\locales\\ja.js'
import locale7867b1d3 from '../..\\locales\\zh.js'
import locale77427e78 from '../..\\locales\\en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"ja"},
  vueI18nLoader: false,
  locales: [{"code":"ja","iso":"ja","file":"ja.js"},{"code":"zh","iso":"zh-CN","file":"zh.js"},{"code":"en","iso":"en-US","file":"en.js"}],
  defaultLocale: "ja",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "C:\\Users\\Administrator\\Desktop\\authen-dangdaidongjing-os-master\\locales\\",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"ja","iso":"ja","file":"ja.js"},{"code":"zh","iso":"zh-CN","file":"zh.js"},{"code":"en","iso":"en-US","file":"en.js"}],
  localeCodes: ["ja","zh","en"],
  additionalMessages: [],
}

export const localeMessages = {
  'ja.js': () => Promise.resolve(locale77830b2a),
  'zh.js': () => Promise.resolve(locale7867b1d3),
  'en.js': () => Promise.resolve(locale77427e78),
}
